import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { change } from 'redux-form';
import { useParams } from 'react-router-dom';
import { FieldForm } from '@app/src/common/FieldForm';
import { Select } from '@app/src/common/Select';
import { COLORS } from '@app/src/ui';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';
import { fetchTypeVehicle } from '@app/src/views/StepOne/form';

interface Props {
  operation: number;
}

export const TypeVehicle: React.FC<Props> = ({ operation }) => {
  const dispatch = useDispatch();
  const { packageId } = useParams();

  const vehicles: SelectItemModel[] = useSelector(state => state.typeVehicle.data);
  const isFetching: boolean = useSelector(state => state.typeVehicle.isFetching);
  const print = useSelector(state => state.print.general);
  const currentTypeVehicle = useSelector(state => state.form.stepOne.values.typeVehicle);

  useEffect(() => {
    dispatch(change('stepOne', 'typeVehicle', print.typeVehicle));
    dispatch(change('stepOne', 'typeVehicleName', print.typeVehicleName));
  }, []);

  useEffect(() => {
    if (packageId) {
      dispatch(fetchTypeVehicle(operation, packageId));
    } else {
      dispatch(fetchTypeVehicle(operation));
    }
    if (operation !== print.operation) {
      dispatch(change('stepOne', 'typeVehicle', null));
      dispatch(change('stepOne', 'typeVehicleName', ''));
    }
  }, [operation]);

  const handleChange = (typeVehicle) => {
    const { id, name } = typeVehicle;
    dispatch(change('stepOne', 'typeVehicle', id));
    dispatch(change('stepOne', 'typeVehicleName', name));
  };

  return (
    <FieldForm label="Tipo de vehículo">
      <Select
        dataList={vehicles}
        handleChange={handleChange}
        placeholder="Seleccionar tipo de vehículo"
        modalTitle="Tipo de vehículo"
        optionColor={COLORS.AMBAR}
        isLoading={isFetching}
        initialIndex={currentTypeVehicle}
      />
    </FieldForm>
  )
};